import { backdoorKey, globalDefines } from './../../app/app.constants';
import { AuthProvider } from './../../providers/auth/auth';
import { CodeProvider } from './../../providers/code/code';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { IonDigitKeyboardOptions } from '../../components/ion-digit-keyboard';
import { User } from '../../models/user';
import { HomePage } from '../home/home';
import { GlobalVars } from '../../app/app.environment';
import _ from 'underscore';


@IonicPage()
@Component({
  selector: 'page-code-input',
  templateUrl: 'code-input.html',
})
export class CodeInputPage {

  code: string = '';
  secretKey: Array<any> = [];

  keyboardSettings: IonDigitKeyboardOptions = {
    align: 'center',
    width: '100%',
    visible: true,
    leftActionOptions: {
        iconName: 'ios-backspace',
        fontSize: '1.4em'
    },
    rightActionOptions: {
        iconName: 'ios-checkmark-circle-outline',
        fontSize: '1.3em'
    },
    roundButtons: false,
    showLetters: false,
    swipeToHide: false,
    theme: 'messenger'
  }

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public authProvider: AuthProvider,
    public codeProvider: CodeProvider,
    public globalVars: GlobalVars,
  ) {}

  enter() {
    let loading = this.loadingCtrl.create();
    loading.present();

    this.codeProvider.getUserByKey(this.code).then((result: string) => {
      this.code = '';

      if(result) {
        this.authProvider.getProfile(result).subscribe((user: User) => { 
          loading.dismiss();
          this.navCtrl.push(HomePage, { user: user });
        });
      }
      else {
        loading.dismiss();
        this.showMessage('No existe ningún usuario con este código.');
      }
    }).catch(error => loading.dismiss())
  }

  onKeyboardButtonClick(key: number) {
    if(this.code.length < 4) this.code += key;
    if(this.code.length == 4) this.enter();
  }

  click(key: any) {
    // Codi secret
    if(this.secretKey.length == backdoorKey.length) this.secretKey.shift()
    this.secretKey.push(key);

    if(_.isEqual(this.secretKey, backdoorKey)) {
      this.authProvider.signOut();
      this.globalVars.user = null;
    }

    // Funcionalitat habitual
    if (typeof key == 'number' && this.code.length < 4) {
      this.code += key;
      if(this.code.length == 4) this.enter();
    } 
    
    else {
      if (key == 'left') this.code = this.code.slice(0, -1);
      if (key == 'right' && this.code.length == 4) this.enter();
    }
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/code-input/code-input.ts